var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_vm._v("\n        2024 © \n        "),_c('a',{attrs:{"href":"https://360sec.com","target":"_blank"}},[_vm._v("360 Security Group")])])])])])
}]

export { render, staticRenderFns }